import { DeliveryType } from '../models/az';
import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from 'typedi';
import { AZ } from '@winelivery-org/wl-client-sdk-js';
import { getApisRoot } from './common';

interface GetAzsArgs {
  geoHash: string;
  deliveryType?: DeliveryType;
}

@Service()
export default class LocalizationService {
  private baseUrl = getApisRoot('wl-localization-service', 'localization');

  async getAzs({ geoHash, deliveryType }: GetAzsArgs): Promise<AZ[]> {
    return await doRequest({
      auth: false,
      method: HttpMethodEnum.GET,
      url: `${this.baseUrl}/v1/azs/`,
      params: {
        geo_hash: geoHash,
        ...(deliveryType && { delivery_type: deliveryType }),
      },
    });
  }
}
